import { filter, ignoreElements, switchMap, tap } from "rxjs/operators";
import { TypeActionViewport } from "../actionViewport";
export var epicViewportZoom = function (action$, state$, deps) {
    return deps.inStoreDependencies.viewportChanged$.pipe(switchMap(function (viewport) {
        return action$.pipe(filter(function (action) {
            return action.type === TypeActionViewport.ZoomIn ||
                action.type === TypeActionViewport.ZoomOut;
        }), tap(function (action) {
            if (action.type === TypeActionViewport.ZoomIn) {
                viewport.zoomPercent(0.2, true);
            }
            else if (action.type === TypeActionViewport.ZoomOut) {
                viewport.zoomPercent(-0.2, true);
            }
            viewport.emit("zoomed", viewport);
        }), ignoreElements());
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/viewport/epics/epicViewportZoom.ts
// module id = 2503
// module chunks = 3